import styled from 'styled-components';

/**
 * Stili del `body` di un Drawer che ospita `ConfigurationCardGroup` in
 * modalità `dense`.
 *
 * Padding azzerato: il body è lo scroll container della barra di subentro
 * sticky (`ConfigurationCardDenseNav`, top:0) e un suo padding-top ne
 * sfaserebbe l'ancora; le card dense sono flat e a tutta larghezza, quindi
 * non c'è spazio laterale da ricreare (vedi `ConfigurationDrawerContent`).
 * `paddingBottom` serve alla `DrawerButtonRow` sticky, senza cui i pulsanti si
 * attaccherebbero al fondo.
 */
export const CONFIGURATION_DRAWER_BODY_STYLE = {
  padding: 0,
  paddingBottom: 24,
} as const;

/**
 * Wrapper del contenuto dei Drawer che ospitano card di configurazione dense.
 * Nessun padding: le card dense sono flat e a tutta larghezza, separate dal
 * solo bordo inferiore su sfondo bianco. Da usare in coppia con
 * `CONFIGURATION_DRAWER_BODY_STYLE` sul `styles.body` del Drawer.
 */
export const ConfigurationDrawerContent = styled.div`
  min-height: 100%;
  background-color: ${props => props.theme.colorBgContainer};

  /* Alert diretti (errori di validazione del form, errori del group): senza il
     padding del contenitore gli diamo noi un po' d'aria. */
  > .ant-alert {
    margin: 12px;
  }

  /* Il DrawerButtonRow compensa con margini negativi il padding 24px dei
     drawer "classici": qui il padding laterale non c'è, azzeriamo la
     compensazione orizzontale (resta quella verticale, che aggancia la riga
     al paddingBottom del body).
     Il border-top della riga è il bordo di CHIUSURA dell'ultima Card dense
     (le card non hanno bordo inferiore, vedi denseFlatChromeCss) */
  .drawer-button-row {
    margin-inline: 0;
    margin-top: 0;
    padding-top: 12px;
    border-top: 3px solid ${props => props.theme.colorSplit};

    > div {
      border-top: none;
      padding-top: 0;
    }
  }
`;
